import { render, staticRenderFns } from "./ViewerDoc.vue?vue&type=template&id=7cc22b52&"
import script from "./ViewerDoc.vue?vue&type=script&lang=js&"
export * from "./ViewerDoc.vue?vue&type=script&lang=js&"
import style0 from "./ViewerDoc.vue?vue&type=style&index=0&id=7cc22b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports